/**
 * Defensive error-message extractor for CDM / OCF / PP submit, correction and
 * cancel operations.
 *
 * BE error bodies are not uniform (see .claude/cdm-context/13-backend-api-spec.md):
 *  - CDM / PP submit + correction errors carry `{ success:false, error:"..." }`.
 *  - OCF submit + correction errors carry `OcfSubmissionResponse{ success:false, message }`.
 *  - Cancel (all 3) carries a typed `*SubmissionResponse{ success:false, message }`.
 *
 * This reads both the axios error shape (`err.response.data`) and an already
 * unwrapped response payload, preferring `message` then `error`, falling back to
 * the supplied generic message.
 */
export const extractSubmissionError = (errorOrData, fallback) => {
  const data = errorOrData?.response?.data ?? errorOrData;

  return (
    data?.message ||
    data?.error ||
    (Array.isArray(data?.validationErrors) && data.validationErrors.length > 0
      ? data.validationErrors.join(", ")
      : null) ||
    fallback ||
    "Something went wrong. Please try again."
  );
};
